import React from 'react';
import { Link } from 'react-router-dom';

const Logo = () => {
  return (
    <Link to="/" className="fixed top-8 left-8 z-50" data-testid="logo" data-cursor-hover>
      <div
        className="text-3xl font-bold tracking-tighter hover:opacity-60 transition-opacity"
        style={{ color: 'var(--text-primary)', fontFamily: 'Nohemi, sans-serif', fontWeight: 900 }}
      >
        UKY
      </div>
    </Link>
  );
};

export default Logo;
